import React from "react";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import TextFieldHelper from "../../UI/FormHelper/TextFieldHelper";
import { Box, Grid } from "@material-ui/core";
import TextFieldRtl from "../../UI/TextFieldRtl/TextFieldRtl";
import LegalEntitySelect from "./recieverable/LegalEntitySelect";
import UserSelect from "./recieverable/UserSelect";
import BankSelect from "./recieverable/BankSelect";

const StyledTextField = TextFieldRtl();

const ChequeAddFromChequeable = (props) => {
  const { values, setFieldValue } = props;

  React.useEffect(() => {}, []);

  // if(values.recieverable_type === ""){
  //   values.recieverable_type = "user"
  // }

  return (
    <Wrapper>
      <Grid item xs={12} md={6} p={1}>
        <Box p={1}>
          <StyledTextField
            name={"recieverable_type"}
            id={"recieverable_type"}
            fullWidth={true}
            label={"نوع گیرنده"}
            variant="outlined"
            SelectProps={{
              native: true,
            }}
            onChange={(e) => {
              setFieldValue("recieverable_id", "");
              setFieldValue("recieverable_name", "");
              setFieldValue("recieverable_type", e.target.value);
            }}
            select
            // defaultValue={"user"}
            // value={"user"}
          >
            <option></option>
            <option
              selected={values.recieverable_type === "user"}
              value={"user"}
            >
              حقیقی
            </option>
            <option
              selected={values.recieverable_type === "legal_entity"}
              value={"legal_entity"}
            >
              حقوقی
            </option>
            <option
              selected={values.recieverable_type === "bank"}
              value={"bank"}
            >
              بانک
            </option>
            {/*<option*/}
            {/*  selected={values.recieverable_type === "other"}*/}
            {/*  value={"other"}*/}
            {/*>*/}
            {/*  سایر*/}
            {/*</option>*/}
          </StyledTextField>
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        {values.recieverable_type === "legal_entity" ? (
          <Wrapper>
            <LegalEntitySelect
              disabledAdd={props.disabledAdd}
              value={values.recieverable_name}
              {...props}
            />
          </Wrapper>
        ) : values.recieverable_type === "user" ? (
          <Wrapper>
            <UserSelect
              {...props}
              disabledAdd={props.disabledAdd}
              value={values.recieverable_name}
            />
          </Wrapper>
        ) : values.recieverable_type === "bank" ? (
          <Wrapper>
            <BankSelect
              {...props}
              disabledAdd={props.disabledAdd}
              value={values.recieverable_name}
            />
          </Wrapper>
        ) : values.recieverable_type === "other" ? (
          <Box p={1}>
            <TextFieldHelper
              title={"گیرنده چک"}
              fieldName={"recieverable_id"}
              {...props}
            />
          </Box>
        ) : (<div></div>)}
        <div style={{ color: "red" }}>{props.errors?.recieverable_id}</div>
      </Grid>
    </Wrapper>
  );
};

export default ChequeAddFromChequeable;
